module.exports = __webpack_public_path__ + "img/cluudpayments.19d5cb66.png";